import * as React from 'react'
import { useState, useEffect } from 'react'
import { captureExceptionWithSentry } from '../sentry'
import { Row, Col } from 'react-bootstrap'
import apiFetch from '../common/apiFetch'
import MicrosoftLoginComponent from './MicrosoftLoginComponent'
import GoogleLoginComponent from './GoogleLoginComponent'

interface Props {
	setUser: (token: string) => void
}

const OauthLoginForm = (props: Props) => {
	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState(false)
	const [errMsg, setErrMsg] = useState('')
	const [msClientId, setMsClientId] = useState('')
	const [googleClientId, setGoogleClientId] = useState('')

	useEffect(() => {
		const root = document.getElementById('root')
		if (root) {
			const msId = root.getAttribute('data-ms-id') || ''
			const gid = root.getAttribute('data-google-id') || ''
			setMsClientId(msId)
			setGoogleClientId(gid)
		}
	}, [])

	const errorColor = {
		color: 'red',
	}

	const logoStyle = {
		background: "url('/images/logo_readpeak.png')",
		backgroundRepeat: 'no-repeat',
		height: '109px',
		width: '307px',
		marginBottom: '20px',
		backgroundColor: '#000000eb',
	}

	const orTextStyle: React.CSSProperties = {
		marginTop: '20px',
		textAlign: 'center',
		color: 'black',
		font: 'normal normal 17px/30px Raleway',
	}

	const formContainerStyle: React.CSSProperties = {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '100vh',
	}

	const inputStyle: React.CSSProperties = {
		width: '310px',
		marginBottom: '10px',
		border: '1px solid #ccc',
		borderRadius: '2px',
	}

	const loginButtonStyle: React.CSSProperties = {
		width: '310px',
	}

	const fieldDescriptionTextColor: React.CSSProperties = {
		color: 'black',
	}

	const handleSubmit = async () => {
		try {
			const resp = await apiFetch(`/external/oauth/login`, {
				credentials: 'same-origin',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ username, password }),
			})
			const result = await resp.json()
			props.setUser(result.data)
		} catch (error) {
			setError(true)
			setErrMsg('Incorrect email or password. Please use your email address as the username')
			captureExceptionWithSentry(error)
		}
	}

	const handleOnFail = (message: string) => {
		setError(true)
		setErrMsg(message)
	}

	return (
		<div style={formContainerStyle}>
			<div style={logoStyle}></div>
			<div className="loginbuttons">
				{msClientId && (
					<div style={{ marginBottom: '10px' }}>
						<MicrosoftLoginComponent
							clientId={msClientId}
							handleOnFail={handleOnFail}
							setUser={props.setUser}
						/>
					</div>
				)}
				{googleClientId && msClientId && (
					<>
						<GoogleLoginComponent
							clientId={googleClientId}
							handleOnFail={handleOnFail}
							setUser={props.setUser}
						/>
						<Row>
							<Col xs={12} style={orTextStyle}>
								<b>OR</b>
							</Col>
						</Row>
					</>
				)}
			</div>
			{error && (
				<div className="alert alert-danger">
					<button className="close" data-close="alert"></button>
					<span>
						{error && errMsg
							? errMsg
							: 'Incorrect email or password. Please use your email address as the username'}
					</span>
				</div>
			)}
			<div>
				<label htmlFor="inputEmail1" className="form-label">
					<p style={fieldDescriptionTextColor}>Work Email Address</p>
				</label>
				<div className="input-container" style={inputStyle}>
					<i className="fa fa-user icon"></i>
					<input
						type="text"
						className="form-control input-width no-border"
						id="inputEmail1"
						onChange={(e: any) => setUsername(e.target.value)}
						placeholder="E-mail Address"
						required
					/>
				</div>
			</div>
			<div>
				<label htmlFor="inputPassword1" className="form-label">
					<p style={fieldDescriptionTextColor}>Password</p>
				</label>
				<div className="input-container" style={inputStyle}>
					<i className="fa fa-lock icon" aria-hidden="true"></i>
					<input
						type="password"
						className="form-control input-width no-border"
						id="inputPassword1"
						onChange={(e: any) => setPassword(e.target.value)}
						placeholder="Password"
						required
					/>
				</div>
			</div>
			<button className="btn btn-primary" style={loginButtonStyle} onClick={handleSubmit}>
				LOGIN{' '}
				<span className="ml-5">
					<i className="fa fa-sign-in" aria-hidden="true"></i>
				</span>
			</button>
		</div>
	)
}
export default OauthLoginForm
